import _ from 'underscore';

import BaseView from '../base-view';
import DelayedListView from '../components/admin-dashboard-list-delayed/view';
import UrgentListView from '../components/admin-dashboard-list-urgent/view';
import AdmissionsListView from '../components/admin-dashboard-list-admissions/view';
import CurrencyView from '../components/field-currency/view';
import CurrencyRateListView from '../components/currency-rate-list/view';
import DateTimeView from '../components/field-date-time/view';

export default BaseView.extend({
	events: {},

	initialize: function() {
		// create subviews
		this.subviews = {
			urgentListView: new UrgentListView({
				el: '.js-notifications'
			}),
			delayedListView: new DelayedListView({
				el: '.js-list-delayed-publications'
			}),
			admissionsListView: new AdmissionsListView({
				el: '.js-list-admissions'
			}),
			currencyView: new CurrencyView({
				el: '.js-search-currency'
			}),
			currenyRateListView: new CurrencyRateListView({
				el: '.js-currency-rate-list'
			}),
			activityDateFromView: new DateTimeView({
				el: '.js-activity-from'
			}),
			activityDateUntilView: new DateTimeView({
				el: '.js-activity-until'
			}),
			reportDateFromView: new DateTimeView({
				el: '.js-report-from'
			}),
			reportDateUntilView: new DateTimeView({
				el: '.js-report-until'
			})
		};

		// setup listeners
		this.listenTo(this.subviews.currencyView.model, 'change:Currency', this.onCurrencyChange);
	},

	/**
	 * Currency change handler
	 * Pass the selected currency to the currency rate list
	 **/
	onCurrencyChange: function(model, value) {
		this.subviews.currenyRateListView.model.set('foreignCurrency', value);
	},

	/**
	 * Render all subviews
	 **/
	render: function() {
		_.each(this.subviews, function(subview) {
			subview.render();
		});

		return this;
	}
});
